export default __webpack_public_path__ + "static/media/ic_phone_call_red.eb2034ad.svg";